export default {
  methods: {
    trimHtml (e) {
      return e.replace(/<\/[^>]*>/g, ' ').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '')
    }
  }
}
